import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { SelectionProvider, MapProvider, ModalProvider } from "./contexts";
import MapBase from "./MapBase";
import "./styles/index.css";
import "./styles/output.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <MapProvider>
    <SelectionProvider>
      <ModalProvider>
        <MapBase />
      </ModalProvider>
    </SelectionProvider>
  </MapProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
